<template>
<div class="calendar-header clear">
    <div class="calendar-box" v-if="this.headOptions.type == 'combination'">
        <div class="calendar-content" :style="{'text-align': this.headStyle.combination}">
            <span class="calendar-prev2" @click="handlePrevYear"></span>
            <span class="calendar-prev" @click="handlePrevMonth"></span>
            <span class="calendar-headDate"> {{this.headOptions.date}} </span>
            <span class="calendar-next" @click="handleNextMonth"></span>
            <span class="calendar-next2" @click="handleNextYear"></span>
        </div>
    </div>
    <div class="calendar-box" v-else>
        <span class="calendar-headDate"> {{this.headOptions.date}} </span>
        <div class="calendar-content dispersion" :style="{float: this.headStyle.checkBtn}">
            <span class="calendar-prev2" @click="handlePrevYear"></span>
            <span class="calendar-prev" @click="handlePrevMonth"></span>
            <span class="calendar-next" @click="handleNextMonth"></span>
            <span class="calendar-next2" @click="handleNextYear"></span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        headOptions: Object
    },
    data() {
        return {
            headStyle: ''
        }
    },
    mounted() {
        this.headStyle = this.headOptions.style;
    },
    methods: {
        // 上一个月
        handlePrevMonth() {
            this.$emit('handlePrevMonth');
        },
        // 上一个月
        handlePrevYear() {
            this.$emit('handlePrevYear');
        },
        // 下一个月
        handleNextMonth() {
            this.$emit('handleNextMonth');
        },
        // 下一个月
        handleNextYear() {
            this.$emit('handleNextYear');
        },
    }
}
</script>

<style lang="less">
.calendar-header {
    width: 100%;
    height: 40px;
    background: rgba(224, 229, 240, 0.3) !important;
    .calendar-box {
        position: relative;
        height: 32px;
        line-height: 32px;
        .calendar-content {
            width: 100%;
            .calendar-prev,
            .calendar-next {
                display: inline-block;
                vertical-align: middle;
                width: 10px;
                height: 14px;
                background: url('../assets/img/pre1.png') no-repeat;
                background-size: contain;
                cursor: pointer;
            }
            .calendar-next {
                background: url('../assets/img/next1.png') no-repeat;
                background-size: contain;
            }
            .calendar-prev2,
            .calendar-next2 {
                display: inline-block;
                vertical-align: middle;
                width: 12px;
                height: 16px;
                background: url('../assets/img/pre2.png') no-repeat;
                background-size: contain;
                cursor: pointer;
            }
            .calendar-prev2 {
                margin-right: 100px;
            }
            .calendar-next2 {
                background: url('../assets/img/next2.png') no-repeat;
                background-size: contain;
                margin-left: 100px;
            }
        }
        .dispersion {
            display: inline;
        }
        .calendar-headDate {
            width: 100px;
            margin: 0 100px;
            vertical-align: middle;
            font-size: 18px;
            color: #424953;
            -webkit-user-select: none;
            -webkit-touch-callout: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        .dispersion-today {
            position: inherit;
        }

        .calendar-center {
            margin: 0 auto;
        }

        .calendar-left {
            float: left;
        }

        .calendar-right {
            float: right;
        }
    }
}
</style>
